import { fmtNum } from "@/lib/api";

// Grouping used for assembly subtotals on the spec sheet & PDF
const UPRIGHT_PARTS = new Set([
  "Vertical",
  "Base Plate",
  "Upright Support (Straight)",
  "Upright Support (Angled)",
]);
const BEAM_PARTS = new Set(["Beam", "Bracket"]);
const PANEL_PARTS = new Set(["Panel"]);

export function assemblySubtotals(components = []) {
  const sum = (set) =>
    components
      .filter((c) => set.has(c.component))
      .reduce((a, c) => a + (c.total_weight_kg || 0), 0);
  return {
    uprights: sum(UPRIGHT_PARTS),
    beams: sum(BEAM_PARTS),
    panels: sum(PANEL_PARTS),
  };
}

export function Subtotals({ components, testid = "subtotals" }) {
  const st = assemblySubtotals(components);
  const rows = [
    { label: "Uprights (verticals + base plates + supports)", val: st.uprights, key: "uprights" },
    { label: "Beam assembly (beams + brackets)", val: st.beams, key: "beams" },
    { label: "Panels", val: st.panels, key: "panels" },
  ];
  return (
    <div className="border-t border-line bg-surfaceAlt" data-testid={testid}>
      <table className="w-full grid-lines">
        <tbody>
          {rows.map((r) => (
            <tr key={r.key} data-testid={`subtotal-${r.key}`}>
              <td className="label-tech" style={{ width: "60%" }}>{r.label}</td>
              <td className="num mono font-bold">{fmtNum(r.val, 2)} kg</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
